<template>
 <div> <!-- Only one element for Transition -->
  <div>
    <div v-if="
      ((participation?.travel.transfers?.filter(t => t.direction === 'RoundTrip').length??0) > 0)
      &&
      (
       participation?.travel.packageMandatory
       ||
        (     (participation?.transportation?.outboundDate?.toDateString() == participation?.travel.startDate.toDateString())
           && (participation?.transportation?.returnDate?.toDateString() == participation?.travel.endDate?.toDateString())
        )
      )">
      <h5 class="mt-3" v-if="(participation?.travel.transfers?.length??0) > 1">Transfert Aller-Retour</h5>
      <div class="small text-muted"><em>( Horaires sous réserve de modifications )</em></div>
      <div
        class="card mt-3 form-check"
        role="button"
        :class="{
          'border-2 border-primary bg-primary bg-opacity-25': roundTripTransferValue == transfert.id,
          'border-danger': roundTripTransferErrorMessage,
          'disabled': transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)}"
        v-for="transfert in participation?.travel.transfers?.filter(t => t.direction === 'RoundTrip')"
        :key="transfert.id">
        <label
        :for="`roundTripTransferSelection_${transfert.id}`"
        class="form-check-label"
        role="button"
        :class="{'disabled': transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)}"
        >
          <div class="card-body d-flex flex-column flex-md-row">
            <div>
              <input :id="`roundTripTransferSelection_${transfert.id}`"
                class="form-check-input"
                type="checkbox"
                name="roundTripTransferSelection"
                :checked="roundTripTransferValue === transfert.id"
                @change="(e) => roundTripValueChanged((e.target as HTMLInputElement).checked ? transfert.id : null)"
                role="button"
                :disabled="transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)"
              />
              <i :class="{ 'fa fa-bus': transfert.type === 'Bus' || transfert.type === 'Autocar', 'fa fa-train': transfert.type === 'Train' }" class="text-primary"></i> Je prendrai le transfert {{ transfert.name }}
              <div v-if="transfert.startDate">Départ : {{ formatDate(transfert.startDate, "DD/MM/YYYY HH:mm") }}</div>
              <div v-if="transfert.meetingPoint">Lieu : {{ transfert.meetingPoint }}</div>
              <div v-if="transfert.details" class="mt-2"><em>Infos : {{ transfert.details }}</em></div>
            </div>
            <div class="ms-auto text-end mt-2 mt-md-0" v-if="transfert.quota > 0">
              <div v-if="transfert.quotaLeft > 0" class="small">
                Sièges restants <span class="border rounded p-1 px-3 ms-1" :class="{'text-danger': transfert.quotaLeft <= 5}">{{ transfert.quotaLeft }}</span>
              </div>
              <div v-else class="small text-danger pe-2">Epuisé</div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div v-if="
      ((participation?.travel.transfers?.filter(t => t.direction === 'Outbound').length??0) > 0)
      && (participation?.transportation?.outboundDate?.toDateString() == participation?.travel.startDate.toDateString())">
      <h5 class="mt-3" v-if="(participation?.travel.transfers?.length??0) > 1">Transfert Aller</h5>
      <div class="small text-muted"><em>( Horaires sous réserve de modifications )</em></div>
      <div
        class="card mt-3 form-check"
        role="button"
        :class="{
          'border-2 border-primary bg-primary bg-opacity-25': outboundTransferValue == transfert.id,
          'border-danger': outboundTransferErrorMessage,
          'disabled': transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)}"
        v-for="transfert in participation?.travel.transfers?.filter(t => t.direction === 'Outbound')"
        :key="transfert.id">
        <label
        :for="`outboundTransferSelection_${transfert.id}`"
        class="form-check-label"
        role="button"
        :class="{'disabled': transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)}"
        >
          <div class="card-body d-flex flex-column flex-md-row">
            <div>
              <input :id="`outboundTransferSelection_${transfert.id}`"
                class="form-check-input"
                type="checkbox"
                name="outboundTransferSelection"
                :checked="outboundTransferValue === transfert.id"
                @change="(e) => outboundValueChanged((e.target as HTMLInputElement).checked ? transfert.id : null)"
                role="button"
                :disabled="transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)"
              />
              <i :class="{ 'fa fa-bus': transfert.type === 'Bus' || transfert.type === 'Autocar', 'fa fa-train': transfert.type === 'Train' }" class="text-primary"></i> Je prendrai le transfert {{ transfert.name }}
              <div v-if="transfert.startDate">Départ : {{ formatDate(transfert.startDate, "DD/MM/YYYY HH:mm") }}</div>
              <div v-if="transfert.meetingPoint">Lieu : {{ transfert.meetingPoint }}</div>
              <div v-if="transfert.details" class="mt-2"><em>Infos : {{ transfert.details }}</em></div>
            </div>
            <div class="ms-auto text-end mt-2 mt-md-0" v-if="transfert.quota > 0">
              <div v-if="transfert.quotaLeft > 0" class="small">
                Sièges restants <span class="border rounded p-1 px-3 ms-1" :class="{'text-danger': transfert.quotaLeft <= 5}">{{ transfert.quotaLeft }}</span>
              </div>
              <div v-else class="small text-danger pe-2">Epuisé</div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div v-if="((participation?.travel.transfers?.filter(t => t.direction === 'Return').length??0) > 0)
      && (participation?.transportation?.returnDate?.toDateString() == participation?.travel.endDate?.toDateString())">
      <h5 class="mt-5" v-if="(participation?.travel.transfers?.length??0) > 1">Transfert Retour</h5>
      <div class="small text-muted"><em>( Horaires sous réserve de modifications )</em></div>
      <div
        class="card mt-3 form-check"
        role="button"
        :class="{'border-2 border-primary bg-primary bg-opacity-25': returnTransferValue == transfert.id, 'border-danger': returnTransferErrorMessage, 'disabled': transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)}"
        v-for="transfert in participation?.travel.transfers?.filter(t => t.direction === 'Return')"
        :key="transfert.id">
        <label
          :for="`returnTransferSelection_${transfert.id}`"
          class="form-check-label"
          role="button"
          :class="{'disabled': transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)}"
        >
          <div class="card-body d-flex flex-column flex-md-row">
            <div>
              <input :id="`returnTransferSelection_${transfert.id}`"
                class="form-check-input"
                type="checkbox"
                name="returnTransferSelection"
                :checked="returnTransferValue === transfert.id"
                @change="(e) => returnValueChanged((e.target as HTMLInputElement).checked ? transfert.id : null)"
                role="button"
                :disabled="transfert.quotaLeft < ((participation?.companions?.length ?? 0)+1)"
              />
              <i :class="{ 'fa fa-bus': transfert.type === 'Bus' || transfert.type === 'Autocar', 'fa fa-train': transfert.type === 'Train' }" class="text-primary"></i> Je prendrai le transfert {{ transfert.name }}
              <div v-if="transfert.startDate">Départ : {{ formatDate(transfert.startDate,"DD/MM/YYYY HH:mm") }}</div>
              <div v-if="transfert.meetingPoint">Lieu : {{ transfert.meetingPoint }}</div>
              <div v-if="transfert.details" class="mt-2 pre-line"><em>Infos : {{ transfert.details }}</em></div>
            </div>
            <div class="ms-auto text-end mt-2 mt-md-0" v-if="transfert.quota > 0">
              <div v-if="transfert.quotaLeft > 0" class="small">
                Sièges restants <span class="border rounded p-1 px-3 ms-1" :class="{'text-danger': transfert.quotaLeft <= 5}">{{ transfert.quotaLeft }}</span>
              </div>
              <div v-else class="small text-danger pe-2">Epuisé</div>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>

  <PageBottomMessage message-key="pageTransfers"></PageBottomMessage>
</div>
</template>

<script lang="ts" setup>
  import { useField } from 'vee-validate';
  import { formatDate } from '@/compositions/helper';

  const participation = defineModel<UserParticipation>();

  const { value: roundTripTransferValue, errorMessage: roundTripTransferErrorMessage, setValue: setRoundTripTransferValue } = useField<number | null>(() => 'transfer.roundTripId');
  const { value: outboundTransferValue, errorMessage: outboundTransferErrorMessage, setValue: setOutboundTransferValue } = useField<number | null>(() => 'transfer.outboundId');
  const { value: returnTransferValue, errorMessage: returnTransferErrorMessage, setValue: setReturnTransferValue } = useField<number | null>(() => 'transfer.returnId');

  const roundTripValueChanged = (newValue: number | null) => {
    if(roundTripTransferValue.value === newValue)
      setRoundTripTransferValue(null);
    else
      setRoundTripTransferValue(newValue);
  }

  const outboundValueChanged = (newValue: number | null) => {
    if(outboundTransferValue.value === newValue)
      setOutboundTransferValue(null);
    else
      setOutboundTransferValue(newValue);
  }

  const returnValueChanged = (newValue: number | null) => {
    if(returnTransferValue.value === newValue)
      setReturnTransferValue(null);
    else
      setReturnTransferValue(newValue);
  }

</script>
